import { render, staticRenderFns } from "./SageExportConflictsDialogComponent.vue?vue&type=template&id=217ed0d0&scoped=true"
import script from "./SageExportConflictsDialogComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./SageExportConflictsDialogComponent.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./SageExportConflictsDialogComponent.vue?vue&type=style&index=0&id=217ed0d0&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "217ed0d0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('217ed0d0')) {
      api.createRecord('217ed0d0', component.options)
    } else {
      api.reload('217ed0d0', component.options)
    }
    module.hot.accept("./SageExportConflictsDialogComponent.vue?vue&type=template&id=217ed0d0&scoped=true", function () {
      api.rerender('217ed0d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Dialog/customDialogs/SageExportConflictsDialogComponent.vue"
export default component.exports